export default "__VITE_ASSET__CyLTCmjf__"